const stats = [
  { value: '12,000+', label: '部漫画资源' },
  { value: '每日更新', label: '从不间断' },
  { value: '全本免费', label: '无需付费' },
];

export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-100/80 text-primary-700 text-xs font-medium rounded-full mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1"></i>每日更新 · 全本免费 · 下拉式阅读
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              妖精漫画网
              <br />
              <span className="text-primary-600">免费漫画大全</span>，全网热门漫画随心看
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading mb-6">
              韩漫日漫国漫，你想看的这里都有
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              妖精漫画网免费漫画资源全覆盖，热门完结连载全部免费看，下拉式阅读体验超爽，追更不等待。奇幻魔幻恋爱题材一网打尽，每日更新热门韩漫、经典日漫、精品国漫，妖精漫画网好看的漫画尽在大全，随时随地在线免费阅读。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-primary-600 whitespace-nowrap">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-book-read-line mr-2"></i>开始阅读
              </a>
              <a
                href="#ranking"
                className="px-8 py-3 border-2 border-primary-300 hover:border-primary-500 text-primary-600 hover:text-primary-700 font-medium rounded-full text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-fire-line mr-2"></i>人气排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/40 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20reading%20scene%20with%20an%20open%20manga%20comic%20book%20on%20a%20wooden%20desk%2C%20soft%20warm%20ambient%20lighting%2C%20a%20cup%20of%20tea%20beside%20the%20book%2C%20colorful%20illustration%20pages%20visible%2C%20Japanese%20and%20Korean%20manga%20style%20artwork%2C%20cozy%20atmosphere%2C%20bookshelf%20in%20background%2C%20evening%20reading%20vibe%2C%20artistic%20composition%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=1200&height=900&seq=hero-manga-main&orientation=landscape"
                  alt="妖精漫画网在线免费阅读漫画 - 舒适的漫画阅读场景"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}